import { render, staticRenderFns } from "./exproess-detail2.vue?vue&type=template&id=270b2b2e&scoped=true"
import script from "./exproess-detail2.vue?vue&type=script&lang=js"
export * from "./exproess-detail2.vue?vue&type=script&lang=js"
import style0 from "./exproess-detail2.vue?vue&type=style&index=0&id=270b2b2e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b2b2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('270b2b2e')) {
      api.createRecord('270b2b2e', component.options)
    } else {
      api.reload('270b2b2e', component.options)
    }
    module.hot.accept("./exproess-detail2.vue?vue&type=template&id=270b2b2e&scoped=true", function () {
      api.rerender('270b2b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/task/components/components/exproess-detail2.vue"
export default component.exports